module.exports = __webpack_public_path__ + "assets/img/slogan-bb70a14a.png";